/**
 * Serviço de Modalidades (Atividades Esportivas)
 *
 * Gerencia operações CRUD de atividades esportivas usando PostgREST.
 * Tabela: atividades_esportivas (id é TEXT, não UUID)
 */

import { postgrestClient } from "../lib/postgrest/client";

/**
 * Serviço de modalidades (atividades esportivas)
 */
export const modalidadesService = {
  /**
   * Lista atividades esportivas com filtros
   * @param {Object} options
   * @param {Object} options.filters - Filtros (ex: { categoria: "eq.Coletiva" })
   * @param {string} options.order - Ordenação (ex: "nome.asc")
   * @param {number} options.limit - Limite de resultados
   * @param {number} options.offset - Offset para paginação
   * @param {boolean} options.includeCount - Se true, retorna { data, total }
   * @returns {Promise<Array|{data: Array, total: number}>}
   */
  async list(options = {}) {
    const { filters = {}, order = "nome.asc", limit, offset, includeCount = false } = options;
    const result = await postgrestClient.get("atividades_esportivas", {
      filters,
      order,
      limit,
      offset,
      includeCount,
    });
    
    // Se includeCount, retorna { data, total }, senão retorna array direto
    if (includeCount && result && typeof result === 'object' && 'data' in result) {
      return result;
    }
    return result;
  },

  /**
   * Busca atividade esportiva por ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  async getById(id) {
    const result = await postgrestClient.get("atividades_esportivas", {
      filters: { id: `eq.${id}` },
    });
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Cria nova atividade esportiva
   * @param {Object} modalidadeData
   * @returns {Promise<Object>}
   */
  async create(modalidadeData) {
    const result = await postgrestClient.post("atividades_esportivas", modalidadeData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Atualiza atividade esportiva
   * @param {string} id
   * @param {Object} modalidadeData
   * @returns {Promise<Object>}
   */
  async update(id, modalidadeData) {
    const result = await postgrestClient.patch("atividades_esportivas", { id }, modalidadeData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Remove atividade esportiva
   * @param {string} id
   * @returns {Promise<null>}
   */
  async delete(id) {
    return postgrestClient.delete("atividades_esportivas", { id });
  },
};

export default modalidadesService;

